module.exports = __webpack_public_path__ + "static/media/worldmap.f3986951.png";